import { Navigate } from 'react-router';

import GlobalSuspenseFallback from '~/pages/Fallback/GlobalSuspenseFallback';

import { useAppEnv } from './useAppEnv';

/**
 * @description 미정의 경로(`*`) 전용 Guard
 * - 브릿지 응답 대기 중: 로딩 화면
 * - 웹뷰/개발 모드: /not-found 로 이동
 * - 브라우저/무응답: 루트로 이동
 *
 * 경로가 겹치는 `*`는 단일 라우트에서 분기하여 중복 매칭/무한 리다이렉트를 방지한다.
 */
const CatchAllGuard = () => {
  const { bridgeStatus, isWebView, isDevMode } = useAppEnv();

  if (!isDevMode && bridgeStatus === 'pending') {
    return <GlobalSuspenseFallback />;
  }

  return isWebView || isDevMode ? <Navigate to="/not-found" replace /> : <Navigate to="/" replace />;
};

export default CatchAllGuard;
